import { render } from "./UserVideos.vue?vue&type=template&id=1be90e2c"
import script from "./UserVideos.vue?vue&type=script&lang=js"
export * from "./UserVideos.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__